import promotionConstants from '../constants/promotion';

const initialState = {
  data: [],
  detail: null,
  selected: null
}

export default function promotion (state=initialState, action) {
  switch (action.type) {
    case promotionConstants.ACTIVEATE_PROMOTION:
      return {
        ...state,
        detail: action.detail
      };
    case promotionConstants.CREATE_PROMOTION:
      return {
        ...state,
        detail: action.detail
      };
    case promotionConstants.DEACTIVATE_PROMOTION:
      return {
        ...state,
        detail: action.detail
      };
    case promotionConstants.LIST_PROMOTION:
      return {
        data: action.data
      };
    case promotionConstants.RETRIEVE_PROMOTION:
      return {
        ...state,
        detail: action.detail
      };
    case promotionConstants.UPDATE_PROMOTION:
      return {
        ...state,
        detail: action.detail
      };
    case promotionConstants.CLEAR_PROMOTION:
      return {
        ...state,
        detail: null,
        data: []
      };
    default:
      return state
  }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/promotion.js
 **/